import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getCounters } from '../api';
import { ECounters, ICounters } from '../api/models/counters/counters.types';
import { favoritesActions } from '../favorites/actions';
import { ActionsOfType } from '../helpers';
import { checkHasCompletedProfile } from '../helpers/checkSaga';
import { photoRequestsAction } from '../photoRequests/actions';
import { visitsActions } from '../visits/actions';
import {
  countersActions,
  ECountersActionType,
  ICountersAction,
} from './actions';
import { counterSerializer, ICounterUpdate } from './counter.serializer';

export function* getCountersSaga() {
  if (!(yield* checkHasCompletedProfile())) return;

  const response: ICounters = yield call(getCounters);

  yield put(countersActions.getCountersSuccess(response));
}

export function* handleCounterUpdateFromWebsocket({
  payload,
}: ActionsOfType<
  ICountersAction,
  ECountersActionType.COUNTER_WEBSOCKET_UPDATE
>) {
  if (!(yield* checkHasCompletedProfile())) return;

  const counterUpdate: ICounterUpdate = yield call(counterSerializer, payload);

  switch (counterUpdate.type) {
    case ECounters.FAVORITE:
      yield put(countersActions.updateFavoriteCounter(counterUpdate.value));
      yield put(favoritesActions.getReceivedFavorites(true));
      break;
    case ECounters.MESSAGE:
      yield put(countersActions.updateMessageCounter(counterUpdate.value));
      break;
    case ECounters.VISIT:
      yield put(countersActions.updateVisitCounter(counterUpdate.value));
      yield put(visitsActions.getVisits(true));
      break;
    case ECounters.PHOTO_REQUEST:
      yield put(countersActions.updatePhotoRequestCounter(counterUpdate.value));
      yield put(photoRequestsAction.getPhotoRequests(true));
      break;
  }
}

export function* countersRootSaga() {
  yield all([
    takeLatest(
      ECountersActionType.GET,
      handleAsyncStatus(getCountersSaga, EAsyncEventTypes.GET_COUNTERS)
    ),
    takeLatest(
      ECountersActionType.COUNTER_WEBSOCKET_UPDATE,
      handleCounterUpdateFromWebsocket
    ),
  ]);
}
